module.exports = "<div class=\"notification-content-view\" ng-show=\"isActive\" ng-transclude></div>";